import React from 'react';
import 'react-quill/dist/quill.snow.css';
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import { useEffect, useState } from "react";
import { Form, Button, Col, Row, Breadcrumb } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { ConvertDateTimeToText } from "components/MyControl";
import Swal from "sweetalert2";
import UtilClass from "api_ref/UtilClass";

export default function PackagePeriodDetail(){
    const api = new ApiConection();
    const utilcls = new UtilClass();
    const nav = useNavigate();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [createMode,setCreateMode] = useState(false);
    const [initialData, setInitialData] = useState({});
    const [simulate, setSimulate] = useState({});
    const urlPathName = window.location.pathname;

    const getData = async () => {
        const response = await api.getData(`api/PackagePeriod/${id}`);
        if (response.status === true) {
            let data = {}
            data = {
                name: response.data.name,
                short_name: response.data.short_name,
                unit_name: response.data.unit_name,
                multiply: response.data.multiply,
                is_default: response.data.is_default,
                active: response.data.active,
                is_show: response.data.is_show,
            }
            setSimulate(data);
            setInitialData(data);
        }
    }
    
    const handleCancel = (event) => {
        if (createMode) {
            nav('/setting/config-packageperiod'); 
        } else {
            setSimulate(initialData);
            setMode('view');
        }
    }

    const handleSetSimulate = async (event) => {
        const { name, value, checked, type } = event.target;

        if(type === 'checkbox'){
            setSimulate(preData => { return { ...preData, [name]: checked } });
        }else{
            setSimulate(preData => { return { ...preData, [name]: value } });
        }
        
    }

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let data = {
            name: simulate.name,
            short_name: simulate.short_name,
            unit_name: simulate.unit_name,
            multiply: simulate.multiply,
            is_default: simulate.is_default,
            active: simulate.active,
            is_show: simulate.is_show
        }

        

        if (urlPathName === (process.env.PUBLIC_URL+'/setting/config-packageperiod/create')){
            const response = await api.postData(`api/PackagePeriod`, data)
            if (response.status === true) {

                nav('/setting/config-packageperiod');
            } else{
                setAlert(response.message);
            }
        } else {
            const response = await api.putData(`api/PackagePeriod/${id}`, data);

            if (response.status === true) {
                Swal.fire({title:'บันทึกสำเร็จ', icon:'success',heightAuto: false});
                await getData();
                setMode('view');
            } else {
                Swal.fire({title:'บันทึกไม่สำเร็จ', icon:'error',heightAuto: false});
                setAlert(response.message);
                setMode('edit');
            }
        }

        setLoading(false);
    }

    const handleBreadcrumbClick = (e) => {
        nav('/setting/config-packageperiod');
    };

    const handleDelete = (id) => {
        Swal.fire({
            title: 'ต้องการลบข้อมูลผู้ใช้ ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0d6efd',
            cancelButtonColor: '#727a82',
            cancelButtonText: 'ยกเลิก',
            confirmButtonText: 'ตกลง',
            heightAuto: false
          }).then((result) => {
            if (result.isConfirmed) {
                api.deleteData(`api/PackagePeriod/${id}`)
                .then((response) => {
                    if (response.status === true) {
                        Swal.fire({title:'ลบสำเร็จ', icon:'success',heightAuto: false});
                        nav('/setting/config-packageperiod');
                    } else {
                        Swal.fire({title:'เกิดข้อผิดพลาด', icon:'error',heightAuto: false});
                    }
                })
            }
        })
    }

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/setting/config-packageperiod/create')){
            setMode('edit');
            setCreateMode(true);
        }
        
    },[urlPathName])

    useEffect(() => {
        getData();
    }, [])
    
    return(
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>ตั้งค่าระยะเวลาแพ็กเกจ</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'รายละเอียดระยะเวลาแพ็กเกจ' :
                                createMode === true ? 'สร้างระยะเวลาแพ็กเกจ' :
                                'แก้ไขระยะเวลาแพ็กเกจ'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'รายละเอียดระยะเวลาแพ็กเกจ' :
                                                createMode === true ? 'สร้างระยะเวลาแพ็กเกจ' :
                                                'แก้ไขระยะเวลาแพ็กเกจ'
                                            }
                                        </h5>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                    
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className='me-3'>
                                            <Form.Group className='mb-3'>
                                                
                                            <Form.Label className='label-title'>ชื่อ <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'name'}
                                                    value={simulate?.name}
                                                    onChange={handleSetSimulate}
                                                    placeholder="ชื่อ" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อย่อ <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'short_name'}
                                                    value={simulate?.short_name}
                                                    onChange={handleSetSimulate}
                                                    placeholder="ชื่อย่อ" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Unit Name <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'unit_name'}
                                                    value={simulate?.unit_name}
                                                    onChange={handleSetSimulate}
                                                    placeholder="Unit Name" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Multiply <span className='text-danger'>*</span></Form.Label>
                                                <Form.Control type={'text'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'multiply'}
                                                    value={simulate?.multiply}
                                                    onChange={handleSetSimulate}
                                                    placeholder="Multiply" 
                                                    required={true} />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>IsDefault</Form.Label>
                                            <Form.Check type={'switch'}
                                                id={'is_default'}
                                                name={'is_default'}
                                                disabled={(mode === 'view') ? true : false}
                                                onChange={event => handleSetSimulate(event)}
                                                checked={simulate?.is_default}
                                                label={(simulate?.is_default == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                            />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>Active</Form.Label>
                                            <Form.Check type={'switch'}
                                                id={'active'}
                                                name={'active'}
                                                disabled={(mode === 'view') ? true : false}
                                                onChange={event => handleSetSimulate(event)}
                                                checked={simulate?.active}
                                                label={(simulate?.active == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                            />
                                            </Form.Group>
                                            <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>IsShow</Form.Label>
                                            <Form.Check type={'switch'}
                                                id={'is_show'}
                                                name={'is_show'}
                                                disabled={(mode === 'view') ? true : false}
                                                onChange={event => handleSetSimulate(event)}
                                                checked={simulate?.is_show}
                                                label={(simulate?.is_show == true) ? 'อนุญาต' : 'ไม่อนุญาต'}
                                            />
                                            </Form.Group>
                                    </Col>
                                    <Col className="me-3">
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่สร้าง</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.create_date)}</Form.Label>
                                        </Form.Group>

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">วันที่แก้ไขล่าสุด</Form.Label>
                                                <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                            </Form.Group>
                                            
                                        }

                                        {
                                            createMode === false &&
                                            <Form.Group as={Row} className="mb-3">
                                                <Form.Label className="label-title">แก้ไขโดย</Form.Label>
                                                <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                            </Form.Group>
                                        }
                                        
                                    </Col>
                                </Row>
                            </div>
                            <Col className='text-end'>
                                {
                                    mode === 'view' &&
                                    <Button variant="outline-danger" type="button" className=''
                                        onClick={event => handleDelete(id)}>
                                        ลบ
                                        <i className="ms-2 fa-solid fa-trash"></i>
                                    </Button>
                                }
                            </Col>

                            {
                                alert != '' &&
                                <div className="alert alert-danger" role="alert">
                                    {alert}
                                </div>
                            }

{
                            <Row>
                                <Col>
                                    {createMode && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                    {!createMode && mode === 'edit' && (
                                        <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                บันทึก
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                        </>
                                    )}
                                </Col>
                            </Row>
                            }
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}